<ng-container *ngLet="datasetOpen | async as isDatasetOpen">
  <div
    class="map-wrapper content-container"
    *ngLet="mapOpen | async as isOpen"
    [class.fullscreen]="isFullscreen"
    [class.dataset-open]="isDatasetOpen"
  >
    <header class="map-header">
      <button class="btn-empty toggle-map-btn link-6" (click)="toggleMap(isOpen)" *ngIf="!isFullscreen; else selectCatalog">
        <svg [icon]="isOpen ? icons.LocationCrossed : icons.Location" class="svg20 mr4" />
        <span>{{ (isOpen ? 'OTHER.HIDE_THE_MAP' : 'OTHER.SHOW_THE_MAP') | translate }}</span>
      </button>

      <h4 class="map-title">{{ title }}</h4>

      <button class="btn-empty toggle-fullscreen-btn" *ngIf="isOpen" (click)="toggleFullscreen()">
        <app-hoverable-svg
          [icon]="!isFullscreen ? icons.FullScreen : icons.FullScreenNon"
          class="svg24 dark-gray-color"
          [matTooltip]="(!isFullscreen ? 'OTHER.FULL_SCREEN' : 'OTHER.NORMAL_SCREEN') | translate"
        ></app-hoverable-svg>
      </button>
    </header>

    <aside class="aside" *ngIf="itemData$ | async as itemData">
      <header class="aside-header">
        <div style="display: flex">
          <button class="btn-empty mr8" (click)="copyLink()" [matTooltip]="'OTHER.COPY_LINK' | translate">
            <app-hoverable-svg [icon]="icons.Links" class="dark-gray-color svg24"></app-hoverable-svg>
          </button>
          <a
            class="btn-empty mr8"
            [routerLink]="appealLink"
            [queryParams]="appealLinkQuery()"
            [matTooltip]="'DATA.SHARED.MORE_VERT_MENU.REPORT_INCORRECT_DATA' | translate"
          >
            <app-hoverable-svg [icon]="icons.Feedback" class="svg24 dark-gray-color"></app-hoverable-svg>
          </a>

          <button
            class="btn-empty"
            (click)="backISelectedItem.emit()"
            [matTooltip]="'OTHER.SHOW_MAP' | translate"
          >
            <app-hoverable-svg [icon]="icons.BackToObject" class="svg24 dark-gray-color"></app-hoverable-svg>
          </button>
        </div>

        <button class="btn-empty" (click)="closeAside()">
          <svg [icon]="icons.Close" class="dark-gray-color svg24" />
        </button>
      </header>
      <div style="height: calc(100% - 35px)">
        <app-catalog-item-card-info [showAllFields]="false" [itemFields]="itemFields$ | async" [itemData]="itemData"></app-catalog-item-card-info>
      </div>
    </aside>

    <div [ngClass]="{ 'disable-map': !isOpen }" class="map">
      <ng-content></ng-content>
    </div>
  </div>

  <ng-template #selectCatalog>
    <button class="btn-empty toggle-dataset-btn" (click)="toggleDataset(isDatasetOpen)">
      <svg [icon]="icons.Autumn" class="svg32 primary-color mr12" />
      <span class="overline primary-color mr4 dataset-name">{{ datasetName }}</span>
      <svg
        [matTooltip]="(!isDatasetOpen ? 'OTHER.SHOW_DATASETS' : 'OTHER.HIDE_DATASETS') | translate"
        [icon]="isDatasetOpen ? icons.ExpandMoreUp : icons.ExpandMoreDown"
        class="svg24 primary-color"
      />
    </button>
  </ng-template>
</ng-container>
